import { render, staticRenderFns } from "./SectionGameAndPlatform.vue?vue&type=template&id=1390dc88&"
import script from "./SectionGameAndPlatform.vue?vue&type=script&lang=js&"
export * from "./SectionGameAndPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports